import type { PaperProps } from '@mui/material';
import { Box, Paper, Typography } from '@mui/material';
import type { Agent } from 'src/data/models/agent.model';
import type { DestinationAddress } from 'src/data/models/destination-address.model';
import { grey, themeConfig } from 'src/theme';
import { Iconify } from '../iconify';

interface Props extends PaperProps {
  agent?: Agent;
  address?: DestinationAddress;
}

export const AgentCard = (props: Props) => {
  const phone = (props.agent?.phone ?? props.address?.phone_number)?.trim();

  return (
    <Paper elevation={8} className="text-white flex flex-col gap-[15px] p-[20px]">
      <Typography variant="h4" color={grey[900]} fontSize={{ xs: '12px', md: '16px', lg: '24px' }}>
        {props.agent?.name ?? props.address?.name}
      </Typography>
      <div className="flex flex-row justify-start items-center gap-1">
        <Box
          className="w-[28px] h-[28px] md:w-[34px] md:h-[34px] flex rounded-[50px] justify-center items-center"
          sx={{
            background: themeConfig.gradient.primary.bold,
          }}
        >
          <Iconify icon="lucide:map-pin" className="text-white" fontSize="8px" />
        </Box>
        <Typography variant="h6" color={grey[900]}>
          {props.agent?.address ?? props.address?.address}
        </Typography>
      </div>
      {phone ? (
        <div className="flex flex-row justify-start items-center gap-1">
          <Box
            className="w-[24px] h-[24px] md:w-[30px] md:h-[30px] flex rounded-[50px] justify-center items-center"
            sx={{
              background: themeConfig.gradient.primary.bold,
            }}
          >
            <Iconify icon="mdi-light:phone" className="text-white" fontSize="8px" />
          </Box>
          <Typography variant="h6" color={grey[900]}>
            {phone}
          </Typography>
        </div>
      ) : null}
    </Paper>
  );
};
